module.exports = __webpack_public_path__ + "025a3a6ac64aa35b83e76101ba6108ee.MP3";